<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item label="宠物ID" prop="petId" >
        <a-input v-model="form.petId" placeholder="请输入宠物ID" />
      </a-form-model-item>
      <a-form-model-item label="设备ID" prop="deviceId" >
        <a-input v-model="form.deviceId" placeholder="请输入设备ID" />
      </a-form-model-item>
      <a-form-model-item label="用户ID" prop="userId" >
        <a-input v-model="form.userId" placeholder="请输入用户ID" />
      </a-form-model-item>
      <a-form-model-item label="体重(kg)" prop="weight" >
        <a-input v-model="form.weight" placeholder="请输入体重(kg)" />
      </a-form-model-item>
      <a-form-model-item label="健康等级：1偏瘦 2标准 3偏胖 4肥胖" prop="healthLevel" >
        <a-input v-model="form.healthLevel" placeholder="请输入健康等级：1偏瘦 2标准 3偏胖 4肥胖" />
      </a-form-model-item>
      <a-form-model-item label="较上次变化率(%)，负数表示下降" prop="changeRate" >
        <a-input v-model="form.changeRate" placeholder="请输入较上次变化率(%)，负数表示下降" />
      </a-form-model-item>
      <a-form-model-item label="是否告警：1是(单日下降>=5%) 0否" prop="isAlert" >
        <a-input v-model="form.isAlert" placeholder="请输入是否告警：1是(单日下降>=5%) 0否" />
      </a-form-model-item>
      <a-form-model-item label="来源：1手动称重 2设备自动" prop="source" >
        <a-input v-model="form.source" placeholder="请输入来源：1手动称重 2设备自动" />
      </a-form-model-item>
      <a-form-model-item label="称重时间" prop="recordTime" >
        <a-date-picker style="width: 100%" v-model="form.recordTime" format="YYYY-MM-DD HH:mm:ss" allow-clear/>
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            保存
          </a-button>
          <a-button type="dashed" @click="cancel">
            取消
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getWeightRecord, addWeightRecord, updateWeightRecord } from '@/api/mibo/weightRecord'

export default {
  name: 'CreateForm',
  props: {
  },
  components: {
  },
  data () {
    return {
      submitLoading: false,
      formTitle: '',
      // 表单参数
      form: {
        id: null,

        petId: null,

        deviceId: null,

        userId: null,

        weight: null,

        healthLevel: null,

        changeRate: null,

        isAlert: null,

        source: null,

        recordTime: null,

        createTime: null,

        remark: null,

      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        petId: [
          { required: true, message: '宠物ID不能为空', trigger: 'blur' }
        ],
        deviceId: [
          { required: true, message: '设备ID不能为空', trigger: 'blur' }
        ],
        userId: [
          { required: true, message: '用户ID不能为空', trigger: 'blur' }
        ],
        weight: [
          { required: true, message: '体重(kg)不能为空', trigger: 'blur' }
        ],
        healthLevel: [
          { required: true, message: '健康等级：1偏瘦 2标准 3偏胖 4肥胖不能为空', trigger: 'blur' }
        ],
        isAlert: [
          { required: true, message: '是否告警：1是(单日下降>=5%) 0否不能为空', trigger: 'blur' }
        ],
        source: [
          { required: true, message: '来源：1手动称重 2设备自动不能为空', trigger: 'blur' }
        ],
        recordTime: [
          { required: true, message: '称重时间不能为空', trigger: 'blur' }
        ]
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.open = false
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        petId: null,
        deviceId: null,
        userId: null,
        weight: null,
        healthLevel: null,
        changeRate: null,
        isAlert: null,
        source: null,
        recordTime: null,
        createTime: null,
        remark: null,
      }
                                  },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = '添加'
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getWeightRecord({"id":id}).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = '修改'
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id !== undefined && this.form.id !== null) {
            updateWeightRecord(this.form).then(response => {

              if(response.success) {
                this.$message.success('修改成功',3)
                this.open = false
                this.$emit('ok')
              } else {
                let messageInfo = response.message || response.msg || '修改失败';
                this.$message.error(messageInfo);
              }

            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addWeightRecord(this.form).then(response => {
              if(response.success) {
                this.$message.success('新增成功',3)
                this.open = false
                this.$emit('ok')
              } else {
                let messageInfo = response.message || response.msg || '新增失败';
                this.$message.error(messageInfo);
              }

            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
